/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/FlowItemBean', 'model/FlowItemResponse', 'model/PartResponse', 'model/ProductResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./FlowItemBean'), require('./FlowItemResponse'), require('./PartResponse'), require('./ProductResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.FlowItemResponse = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.FlowItemBean, root.BpmbuildUatDsappspotcom.FlowItemResponse, root.BpmbuildUatDsappspotcom.PartResponse, root.BpmbuildUatDsappspotcom.ProductResponse);
  }
}(this, function(ApiClient, FlowItemBean, FlowItemResponse, PartResponse, ProductResponse) {
  'use strict';

  /**
   * The FlowItemResponse model module.
   * @module model/FlowItemResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>FlowItemResponse</code>.
   * @alias module:model/FlowItemResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>FlowItemResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FlowItemResponse} obj Optional instance to populate.
   * @return {module:model/FlowItemResponse} The populated <code>FlowItemResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = FlowItemBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('fileUrls'))
        obj.fileUrls = ApiClient.convertToType(data['fileUrls'], ['String']);
      if (data.hasOwnProperty('flowId'))
        obj.flowId = ApiClient.convertToType(data['flowId'], 'String');
      if (data.hasOwnProperty('flowItemList'))
        obj.flowItemList = ApiClient.convertToType(data['flowItemList'], [FlowItemResponse]);
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('imageUrls'))
        obj.imageUrls = ApiClient.convertToType(data['imageUrls'], ['String']);
      if (data.hasOwnProperty('inputJson'))
        obj.inputJson = ApiClient.convertToType(data['inputJson'], 'String');
      if (data.hasOwnProperty('inputPartList'))
        obj.inputPartList = ApiClient.convertToType(data['inputPartList'], [PartResponse]);
      if (data.hasOwnProperty('inputProductList'))
        obj.inputProductList = ApiClient.convertToType(data['inputProductList'], [ProductResponse]);
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('notes'))
        obj.notes = ApiClient.convertToType(data['notes'], 'String');
      if (data.hasOwnProperty('outputJson'))
        obj.outputJson = ApiClient.convertToType(data['outputJson'], 'String');
      if (data.hasOwnProperty('outputPartList'))
        obj.outputPartList = ApiClient.convertToType(data['outputPartList'], [PartResponse]);
      if (data.hasOwnProperty('outputProductList'))
        obj.outputProductList = ApiClient.convertToType(data['outputProductList'], [ProductResponse]);
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
      if (data.hasOwnProperty('sequence'))
        obj.sequence = ApiClient.convertToType(data['sequence'], 'Number');
      if (data.hasOwnProperty('statusList'))
        obj.statusList = ApiClient.convertToType(data['statusList'], ['String']);
      if (data.hasOwnProperty('toolGroupId'))
        obj.toolGroupId = ApiClient.convertToType(data['toolGroupId'], 'String');
      if (data.hasOwnProperty('toolId'))
        obj.toolId = ApiClient.convertToType(data['toolId'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {Boolean} active
   */
  exports.prototype.active = undefined;

  /**
   * @member {module:model/FlowItemBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {Array.<String>} fileUrls
   */
  exports.prototype.fileUrls = undefined;

  /**
   * @member {String} flowId
   */
  exports.prototype.flowId = undefined;

  /**
   * @member {Array.<module:model/FlowItemResponse>} flowItemList
   */
  exports.prototype.flowItemList = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Array.<String>} imageUrls
   */
  exports.prototype.imageUrls = undefined;

  /**
   * @member {String} inputJson
   */
  exports.prototype.inputJson = undefined;

  /**
   * @member {Array.<module:model/PartResponse>} inputPartList
   */
  exports.prototype.inputPartList = undefined;

  /**
   * @member {Array.<module:model/ProductResponse>} inputProductList
   */
  exports.prototype.inputProductList = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} notes
   */
  exports.prototype.notes = undefined;

  /**
   * @member {String} outputJson
   */
  exports.prototype.outputJson = undefined;

  /**
   * @member {Array.<module:model/PartResponse>} outputPartList
   */
  exports.prototype.outputPartList = undefined;

  /**
   * @member {Array.<module:model/ProductResponse>} outputProductList
   */
  exports.prototype.outputProductList = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  /**
   * @member {Number} sequence
   */
  exports.prototype.sequence = undefined;

  /**
   * @member {Array.<String>} statusList
   */
  exports.prototype.statusList = undefined;

  /**
   * @member {String} toolGroupId
   */
  exports.prototype.toolGroupId = undefined;

  /**
   * @member {String} toolId
   */
  exports.prototype.toolId = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/FlowItemResponse.js